import { forgetAllFiles } from './fileHandles';

/**
 * The sessionStorage keys the uploaders persist under. Named here, apart from
 * the stores that write them, because sign-out has to clear them too: a tab
 * survives a sign-out, and the next account signed in on it must not inherit
 * the previous one's uploads.
 */
export const UPLOAD_SESSION_KEY = 'tr.uploadSession';
/** The enterprise upload page's rows (enterprise/upload/store.ts). */
export const ENTERPRISE_UPLOADS_KEY = 'tr.enterpriseUploads';
/** Images whose upload the person left on purpose (leftUploads.ts), in localStorage. */
export const LEFT_UPLOADS_KEY = 'tr.leftUploads';

let cleared = false;

/** Whether sign-out has cleared the storage in this page: nothing may write it again before the reload. */
export function uploadStorageCleared(): boolean {
  return cleared;
}

export function clearUploadStorage(): void {
  cleared = true;
  // The files kept for resuming uploads (fileHandles.ts), in IndexedDB.
  void forgetAllFiles();
  try {
    window.sessionStorage.removeItem(UPLOAD_SESSION_KEY);
    window.sessionStorage.removeItem(ENTERPRISE_UPLOADS_KEY);
    window.localStorage.removeItem(LEFT_UPLOADS_KEY);
  } catch {
    /* storage unavailable: nothing was persisted either */
  }
}
